<template>
  <v-container>
    <back-btn />
    <v-row>
      <v-col lg="12">
             <patient-family-form @emitData="submitData" :familyMember="eachFamilyMember" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import PatientFamilyForm from "@/components/patient/family/PatientFamilyForm.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
export default {
    created()
    {
        this.$store.dispatch("FamilyMember/getEach",this.$route.params.id);
    },
    computed: {
         ...mapGetters("FamilyMember", ["eachFamilyMember"]),
    },
    components: {
        PatientFamilyForm,BackBtn
    },
    methods: {
        submitData(data)
        {
            data.id=this.$route.params.id;
             this.$store.dispatch("FamilyMember/edit",data);
        }
    }

}
</script>

<style>

</style>